import { get } from 'lodash';
import { createSelector } from 'reselect';

import {
    EditedBanner,
    EditedBannerFullContacts,
    InvalidBannerPromocodes,
    PromocodesRestrictedDomains
} from '../../typings/bannersEditState';
import { State } from '../../typings/state';

export const selectBannersInvalidPromocodes = createSelector(
    (state: State) => state.editBanners.banners,
    (state: State) => state.editBanners.promocodes,
    (banners: Record<string, EditedBanner>, promocodes: PromocodesRestrictedDomains): InvalidBannerPromocodes => {
        return Object.keys(banners).reduce((acc: InvalidBannerPromocodes, bannerId: string) => {
            const banner: EditedBanner = banners[bannerId];
            const contacts: EditedBannerFullContacts = get(banner, 'contacts');

            if (!contacts) {
                return acc;
            }

            const currentPromocodes: Array<string> = promocodes[banner.campaign.id];

            if (
                banner.isPromocodeActive &&
                currentPromocodes &&
                !currentPromocodes.some(promo => contacts.href.split(/\/|\?|\#/)[0].toLowerCase() === promo)
            ) {
                if (acc[currentPromocodes[0]]) {
                    return {
                        ...acc,
                        [currentPromocodes[0]]: [...acc[currentPromocodes[0]], banner.id]
                    };
                }
                return { ...acc, [currentPromocodes[0]]: [bannerId] };
            } else {
                return acc;
            }
        }, {});
    }
);
